import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { SelectInputMulti } from '@uhg-abyss/web/ui/SelectInputMulti';
import { isUndefined, orderBy, sortBy } from 'lodash';
import React, { useMemo } from 'react';

import fields from '../includes/fields.json';

/**
 * field: Views
 *
 * Displays a dropdown to select a view.
 *
 * @param assets
 * @param form
 * @param setIsSelectingViews
 * @returns {Element}
 * @constructor
 */
export function Views({ assets = {}, form = {}, setIsSelectingViews = () => {} }) {
  const activeUserDefinedTags = useMemo(() => {
    return assets?.ListTags?.data?.content?.filter((tag) => {
      return tag?.userDefined === true && tag?.enabled === true;
    });
  }, [assets?.ListTags?.data]);

  const viewOptions = useMemo(() => {
    const options = assets?.ListViews?.data
      ?.filter((view) => {
        return view?.status === 'ACTIVE';
      })
      ?.map((view) => {
        return {
          label: view?.name,
          value: view?.id,
        };
      })
      ?.filter((option) => {
        if (option?.value?.startsWith('filter-by-tags-categories-X')) {
          const tagId = option.value.replace('filter-by-tags-categories-', '');
          return activeUserDefinedTags?.some((tag) => {
            return tag.categoryCode === tagId;
          });
        }
        return true;
      });

    options?.push({
      label: 'Risk Records Sample Data',
      value: 'risk-records',
    });

    const sortedOptions = sortBy(options, [
      (view) => {
        return view.label;
      },
    ]);

    const theViews = {};

    sortedOptions.forEach((option) => {
      let section = 'Other';

      if (option?.value.includes('-count')) {
        section = 'Counts';
      } else if (option?.value.includes('-date')) {
        section = 'Dates';
      } else if (option?.value === 'filter-by-tags') {
        section = 'Tags';
      } else if (option?.value.includes('filter-by-tags-categories')) {
        if (option?.value.startsWith('filter-by-tags-categories-X')) {
          section = 'Tags (User Defined)';
        } else {
          section = 'Tags (System Defined)';
        }
      }

      if (isUndefined(theViews[section])) {
        theViews[section] = [];
      }

      if (!theViews[section].includes(option)) {
        let label = `${option.label} (${section})`;

        if (option?.value.startsWith('filter-by-tags-categories')) {
          label = `${option.label} ${section.replace('Tags ', '')}`;
        }

        theViews[section].push({
          ...option,
          ...{
            label,
          },
        });
      }
    });

    const selectableOptions = [];

    Object.keys(theViews).forEach((section) => {
      selectableOptions.push({
        items: theViews[section],
        section,
      });
    });

    return orderBy(selectableOptions, ['section'], ['asc']);
  }, [assets?.ListViews?.data]);

  return (
    <ErrorHandler location="src/features/RiskAnalysis/components/fields/Views/Views.jsx">
      <SelectInputMulti
        {...fields?.views}
        maxListHeight="350px"
        onOpenChange={(isOpen) => {
          setIsSelectingViews(isOpen);
        }}
        options={viewOptions}
      />
    </ErrorHandler>
  );
}
